export default "__VITE_ASSET__BcZyg6pI__"